import Route from 'mewe/routes/route';

export default Route.extend({
  theme: 'group',

  model() {
    return {
      group: this.modelFor('app.group').group,
    };
  },
});
